/* WEAT CUSTOM – mobile swipe on product tiles. Updates the segment indicator and
   resets to the first image when a colour swatch is picked. Uses event delegation,
   so it also works on tiles loaded later (filters, sorting, pagination). */
(() => {
  if (window.__weatCardSwipe) return;
  window.__weatCardSwipe = true;

  const TRACK = '.product-card__media--swipe';
  const pending = new WeakMap();

  const update = (track) => {
    const dots = track.parentElement && track.parentElement.querySelectorAll('.product-card__swipe-dots > span');
    if (!dots || !dots.length || !track.clientWidth) return;
    const index = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
    dots.forEach((dot, n) => dot.classList.toggle('is-active', n === index));
  };

  document.addEventListener('scroll', (event) => {
    const track = event.target;
    if (!(track instanceof Element) || !track.matches(TRACK) || pending.get(track)) return;
    pending.set(track, true);
    requestAnimationFrame(() => {
      pending.delete(track);
      update(track);
    });
  }, { capture: true, passive: true });

  document.addEventListener('change', (event) => {
    const card = event.target instanceof Element ? event.target.closest('product-card') : null;
    const track = card && card.querySelector(TRACK);
    if (track && track.scrollLeft !== 0) track.scrollTo({ left: 0, behavior: 'smooth' });
  });
})();
